import { CompanyDetail as CompanyDetailPage } from 'ui/components/agent/patterns/CompanyDetail/CompanyDetail';

/**
 * 売り手企業詳細
 */
export const CompanyDetail: React.FC = () => {
    return <CompanyDetailPage />;
};
